














import { Component, Vue } from 'vue-property-decorator';
import ProfileUser from '@/components/ProfileUser.vue';
import ProfileCompany from '@/components/ProfileCompany.vue';
import { getConnectedUser } from '@/api/api';
import User from '@/models/User';
import Company from '../models/Company';

@Component({
    components: {
        ProfileUser,
        ProfileCompany,
    },
})
export default class Profile extends Vue {
    user: User | null = null;
    company: Company | null = null;

    async created() {
        const dataUser = await getConnectedUser();
        this.user = dataUser.data;
        this.company = this.user.company || null;
    }
}
